import useHerobanner from "../hooks/useHerobanner";
import ImageRotationAnimation from "./ImageRotationAnimation";
import BannerCategoryies from "./BannerCategoryies";
import HomeSearch from "./HomeSearch";

const HeroBanner = ({ data }) => {
  const { currentSet } = useHerobanner(data);
  return (
    <>
      <div className="spacer_track" />
      <div className="homepage container-fluid position-relative">
        {/* New Image Rotation Animation */}
        {currentSet && (
          <ImageRotationAnimation
            images={currentSet}
            logoUrl={data?.logo_content?.logo}
          />
        )}

        {/* CATEGORIES */}

        <BannerCategoryies />

        {/* Description */}
        <div className="position-absolute description-hero text-secondary">
          <p>
            We believe home is more than just a place. It's a feeling. That’s
            why we design enduring products that strike the perfect balance
            between charm and practicality.
          </p>
        </div>

        <HomeSearch />


      </div>
    </>
  );
};
export default HeroBanner;
